export default __webpack_public_path__ + "static/media/step4.c93af811.png";